<!--
 * @Author: your name
 * @Date: 2022-02-10 13:57:32
 * @LastEditTime: 2022-04-28 15:44:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \veterans-client-ui\src\views\mobile\detail\Detail.vue
-->
<template>
    <div class="box_M">
        <div class="info_box_m detail">
            <h1>{{detailContent.title}}</h1>
            <div class="source" v-if="detailContent.date ? true : false"><span>发布日期:</span>{{detailContent.date}}</div>
            <div class="content">
                <div class="content_detail" v-html="detailContent.content"></div>
                <div class="file" v-if="showFiles">
                    <h2>附件:</h2>
                    <ul>
                        <li v-for="item in detailContent.files" :key="item.name"><a :href="item.url">{{item.name}}</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { getDetail } from '@/service/api.js'
import { dateFormat, createContentMeta } from '@/utils/util.js'

export default {
    components: { BottomMenu },
    data() {
        return {
            detailContent:{
                title:'',
                content:'',
                date:'',
                files:[]
            },
            showFiles:false,
        }
    },
    beforeCreate () {
        getDetail(this.$route.params.id).then(data=>{
            if (data.code!==0) {
                this.$toast(data.msg)
            }else{
                Object.assign(this.detailContent,data.data)
                console.log('getDetail',this.detailContent);
                this.detailContent.files ? this.detailContent.files = JSON.parse(this.detailContent.files) : this.detailContent.files = ''
                this.detailContent.date ? this.detailContent.date = dateFormat(data.data.pushTime,'Y年M月D日') : this.detailContent.date = ''
                if (this.detailContent.files===null || this.detailContent.files[0].name==='') {
                    this.showFiles = false
                }else{
                    this.showFiles = true
                }
                // 添加meta标签
                let temp = {
                'ColumnName': this.detailContent.typeName,
                'ColumnType': this.detailContent.typeName,
                'ArticleTitle': this.detailContent.title,
                'PubDate': this.detailContent.date,
                'ContentSource': this.detailContent.source,
                'Author': this.detailContent.author
                }
                createContentMeta(temp)
            }
        });
    },
}
</script>